export default __webpack_public_path__ + "static/blog-img1-bde8ac4ab9013a873ca14e51fcfc5d19.jpg";